/*
 * VQ Collapsible Content — Seiten-Navigation.
 * Verbindet die Liste links mit den Aufklappern rechts: Klick oeffnet die
 * Zeile, beim Scrollen wandert die Markierung mit. Gescrollt wird nie.
 */
(() => {
  // Die Messlinie des Scroll-Spy liegt so weit unter dem Header.
  const OFFSET_EXTRA = 24;

  const headerOffset = () => {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    const value = parseFloat(raw);
    return (Number.isNaN(value) ? 0 : value) + OFFSET_EXTRA;
  };

  const init = (root) => {
    if (root.dataset.vqTocReady === 'true') return;

    const links = Array.from(root.querySelectorAll('[data-vq-toc-target]'));
    if (!links.length) return;

    const entries = links
      .map((link) => {
        const details = document.getElementById(link.dataset.vqTocTarget);
        if (!details) return null;
        return { link, details, row: details.closest('.accordion') || details };
      })
      .filter(Boolean);
    if (!entries.length) return;

    root.dataset.vqTocReady = 'true';
    const singleOpen = root.dataset.singleOpen !== 'false';

    let activeIndex = -1;
    const setActive = (index) => {
      if (index === activeIndex) return;
      activeIndex = index;
      entries.forEach((entry, i) => {
        entry.link.classList.toggle('is-active', i === index);
        if (i === index) {
          entry.link.setAttribute('aria-current', 'true');
        } else {
          entry.link.removeAttribute('aria-current');
        }
      });
    };

    const closeOthers = (keep) => {
      entries.forEach((entry) => {
        if (entry !== keep) entry.details.open = false;
      });
    };

    entries.forEach((entry, index) => {
      // Kein Sprung zur Zeile: die Aufklapper stehen neben der Navigation und
      // sind ohnehin im Blick. Der Standard-Sprung des Ankers wird deshalb
      // unterbunden, geoeffnet wird nur.
      entry.link.addEventListener('click', (event) => {
        event.preventDefault();
        if (singleOpen) closeOthers(entry);
        entry.details.open = true;
        setActive(index);
      });

      entry.details.addEventListener('toggle', () => {
        if (!entry.details.open) return;
        if (singleOpen) closeOthers(entry);
        setActive(index);
      });
    });

    // Aktiv ist die letzte Zeile, deren Oberkante die Messlinie passiert hat.
    let ticking = false;
    const spy = () => {
      ticking = false;
      const line = headerOffset() + 8;
      let index = 0;
      entries.forEach((entry, i) => {
        if (entry.row.getBoundingClientRect().top <= line) index = i;
      });
      setActive(index);
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(spy);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    spy();
  };

  const boot = (scope) => {
    (scope || document).querySelectorAll('[data-vq-collapsible-toc]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  // Theme-Editor: Section wurde neu geladen.
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
